export const blockIconsUiactionsExpandMoreNew = (
	<span className='material-symbols-outlined'>expand_more</span>
);
